import { Component, OnInit } from '@angular/core';
import { CalculationService } from './calculation.service';
// import { AmortGraphService } from './amort-graph.service';
// import { ChartsModule } from 'ng2-charts';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [CalculationService] // , AmortGraphService]
})
export class AppComponent implements OnInit {
  hide = true;

  constructor(private calcService: CalculationService) {

    this.calcService.dataToEmit.subscribe(
      (dataFromForm: { hide: boolean }) => {
        this.hide = dataFromForm.hide;
      }
    );
  }

  ngOnInit() {
    setTimeout(() => {
    }, 2000);
  }
}



// WEBPACK FOOTER //
// D:/IT-Projects/Projects/amortization/amortization-v03.1.1/src/app/app.component.ts